import { __require as n } from "./_trimmedEndIndex.js";
var e, i;
function _() {
  if (i) return e;
  i = 1;
  var a = n(), m = /^\s+/;
  function u(r) {
    return r && r.slice(0, a(r) + 1).replace(m, "");
  }
  return e = u, e;
}
export {
  _ as __require
};
